import { SettingsService } from './../setting-service/setting.service';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";


@Injectable({ providedIn: 'root' })
export class HttpService {

    private get host(): string {
        return this.settingsService.configUso.urlApiPadrao;
    }

    constructor(private http: HttpClient,
      private settingsService: SettingsService
      ) {


    }


   public setHeaderConfig(authToken?: boolean, headers?: any, ltmToken?: boolean): any {
        let config:any = {
            headers: {
                "x-token": this.settingsService.configUso.X_TOKEN_API
            }
        };

        if (ltmToken) {
            config.headers["ltm-token"] = this.settingsService.configUso.cloudLoyalty.tokenLTM;
        }

        if (authToken) {
            config.headers["auth-token"] = this.settingsService.user.token;
        }

        if (headers) {
            config.headers = headers;
        }

        return config.headers;
    }

    get(endpoint: string, params: any = {}, headers: any = {}): Observable<any> {
        return this.http.get(this.host + endpoint, {
            params: params,
            headers: new HttpHeaders(headers)
        });
    }

    post(endpoint: string, body: any = {}, headers: any = {}): Observable<any> {
        return this.http.post(this.host + endpoint, body, {
            headers: new HttpHeaders(headers)
        });
    }

    put(endpoint: string, body: any = {}, headers: any = {}): Observable<any> {
        return this.http.put(this.host + endpoint, body, {
            headers: new HttpHeaders(headers)
        });
    }

    delete(endpoint: string, params: any = {}, headers: any = {}): Observable<any> {
        return this.http.delete(this.host + endpoint, {
            params: params,
            headers: new HttpHeaders(headers)
        });
    }

    getExternal(endpoint: string, params: any = {}, headers: any = {}): Observable<any> {
        return this.http.get(endpoint, {
            params: params,
            headers: new HttpHeaders(headers)
        });
    }

    downloadDocument(endpoint: string, params: any = {}, headers: any = {}) {
        return this.http.get(this.host + endpoint, {
            params: params,
            headers: new HttpHeaders(headers)
        });
    }

    postExternal(endpoint: string, body: any = {}, headers: any = {}): Observable<any> {
        return this.http.post(endpoint, body, {
          headers: new HttpHeaders(headers)
      });
    }

    getBlob(endpoint: string, params: any = {}, headers: any = {}): Observable<any> {
        const finalHeaders = new HttpHeaders({
            ...headers,
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,*/*'
        });
        
        return this.http.get(this.host + endpoint, {
            params: params,
            headers: finalHeaders,
            responseType: 'blob'
        });
    }

}
